import axios from "axios";
import { axiosErrorHandler } from "../../utility/action-helper";
import { getLiveSuggestion } from "../live-suggestion/liveSuggestionSlice";
import { formatTelegramLog } from "../../utility/formatter-helper";

const initialState = {
  analyze: [],
  status: "",
  errorMessage: "",
  result: {},
};

export const otherCoinsAnalyze = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "analyze_other_coins_request":
      return {
        ...state,
        status: "loading",
        errorMessage: "",
      };

    case "analyze_other_coins_success":
      console.log(payload);
      // console.log(
      //   "analyze data:",
      //   [payload, ...state.analyze],
      //   state.analyze,
      //   payload,
      // );
      return {
        ...state,
        status: "success",
        analyze: [payload, ...state.analyze],
      };

    case "analyze_other_coins_error":
      return {
        ...state,
        status: "error",
      };

    case "analyze_other_coins_cancelled":
      return {
        ...state,
        status: "",
      };

    case "analyze_other_coins_result":
      return {
        ...state,
        result: payload,
      };

    case "reset_other_coins":
      return { ...initialState, analyze: state.analyze };

    default:
      return state;
  }
};

function chunkCoins(coins, size) {
  const groups = [];
  for (let index = 0; index < coins.length; index += size) {
    groups.push(coins.slice(index, index + size));
  }
  return groups;
}

function publishAnalyzeResult(
  dispatch,
  user,
  email,
  exchange_id,
  selectedCoins,
  responseData,
) {
  const successAnalyzeList =
    responseData?.coin_analytics_success_coins_list || [];
  const failedAnalyzeList =
    responseData?.coin_analytics_failed_coins_list || [];
  const analyzeResult = responseData?.other_coins_analyse || [];

  dispatch({ type: "analyze_other_coins_result", payload: responseData });

  if (successAnalyzeList.length) {
    successAnalyzeList.forEach((coin) => {
      const coinAnalyze = analyzeResult.find(
        (analyze) => analyze?.SYMBOL_NAME === coin,
      );
      dispatch({
        type: "analyze_other_coins_success",
        payload: coinAnalyze,
      });
      dispatch(getLiveSuggestion(user, email, exchange_id, coin));
    });
    return;
  }

  if (
    failedAnalyzeList.length === selectedCoins.length ||
    failedAnalyzeList.length === 0
  ) {
    dispatch({ type: "analyze_other_coins_error" });
  }
}

export const analyzeOtherCoins =
  (
    user,
    email,
    market_type,
    other_coins_to_analyse,
    exchange_id,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: "analyze_other_coins_request" });

    const url =
      "https://hav8w1xk8h.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const selectedCoins = Array.isArray(other_coins_to_analyse)
      ? other_coins_to_analyse
      : [];
    const data = {
      platform_mode: "trade_assistant",
      user,
      email,
      market_type,
      exchange_id,
      request_type: "get_trade_suggestion",
      other_coins_to_analyse: selectedCoins,
    };
    const groups =
      market_type === "crypto" && selectedCoins.length > 5
        ? chunkCoins(selectedCoins, 5)
        : [selectedCoins];

    if (groups.length > 1) {
      const settled = await Promise.all(
        groups.map(async (group) => {
          try {
            const res = await axios.post(
              url,
              { ...data, other_coins_to_analyse: group },
              { signal },
            );
            return { ok: true, group, data: res?.data };
          } catch (err) {
            return { ok: false, group, err };
          }
        }),
      );

      if (settled.some((item) => !item.ok && axios.isCancel(item.err))) {
        dispatch({ type: "analyze_other_coins_cancelled" });
        return;
      }

      const successAnalyzeList = [];
      const failedAnalyzeList = [];
      const analyzeResult = [];
      settled.forEach((item) => {
        if (!item.ok) {
          failedAnalyzeList.push(...item.group);
          return;
        }
        successAnalyzeList.push(
          ...(item.data?.coin_analytics_success_coins_list || []),
        );
        failedAnalyzeList.push(
          ...(item.data?.coin_analytics_failed_coins_list || []),
        );
        analyzeResult.push(...(item.data?.other_coins_analyse || []));
      });

      const accounted = new Set([
        ...successAnalyzeList,
        ...failedAnalyzeList,
      ]);
      selectedCoins.forEach((coin) => {
        if (!accounted.has(coin)) failedAnalyzeList.push(coin);
      });

      publishAnalyzeResult(dispatch, user, email, exchange_id, selectedCoins, {
        coin_analytics_success_coins_list: successAnalyzeList,
        coin_analytics_failed_coins_list: failedAnalyzeList,
        other_coins_analyse: analyzeResult,
      });
      return;
    }

    await axios
      .post(url, data, { signal })
      .then((res) => {
        publishAnalyzeResult(
          dispatch,
          user,
          email,
          exchange_id,
          selectedCoins,
          res?.data,
        );

        // const modal = Modal.info({
        //   icon: null,
        //   content: renderContent(false),
        //   centered: true,
        //   footer: null,
        // });
        //
        // function renderContent(loading) {
        //   return (
        //     <div>
        //       <div
        //         style={{
        //           display: "flex",
        //           gap: ".5rem",
        //           alignItems: "center",
        //           marginBottom: "1rem",
        //         }}
        //       >
        //         <FaCircleCheck
        //           color={
        //             successedAnalyzedNumbers === selectedCoinsNumbers
        //               ? "#0AAF47"
        //               : "rgb(187 187 187)"
        //           }
        //           size={20}
        //         />
        //         <h4 style={{ marginBottom: 0, fontSize: "1rem" }}>
        //           {successedAnalyzedNumbers} / {selectedCoinsNumbers} Completed
        //         </h4>
        //       </div>
        //       <div
        //         style={{
        //           display: "flex",
        //           justifyContent: "flex-end",
        //           gap: "1rem",
        //         }}
        //       >
        //         {!!failedAnalyzedNumbers && (
        //           <Button
        //             type="primary"
        //             loading={loading}
        //             onClick={async () => {
        //               modal.update({ content: renderContent(true) });
        //               await dispatch(
        //                 analyzeOtherCoins(
        //                   user,
        //                   email,
        //                   market_type,
        //                   failedAnalyzeList,
        //                   exchange_id,
        //                 ),
        //               );
        //               modal.destroy();
        //             }}
        //           >
        //             Retry
        //           </Button>
        //         )}
        //         <Button onClick={() => modal.destroy()}>Close</Button>
        //       </div>
        //     </div>
        //   );
        // }
      })
      .catch((err) => {
        console.log(err);
        if (axios.isCancel(err)) {
          dispatch({ type: "analyze_other_coins_cancelled" });
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              analyzeOtherCoins(
                user,
                email,
                market_type,
                other_coins_to_analyse,
                exchange_id,
                signal,
                retryCount + 1,
              ),
            "analyze_other_coins_error",
            user,
            email,
            formatTelegramLog(
              "get_trade_suggestion/other_coins_to_analyse",
              data,
              url,
            ),
            0,
            currentPath,
          );
        }
      });
  };

export const resetOtherCoinsState = () => (dispatch) => {
  dispatch({ type: "reset_other_coins" });
};
